import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { RruleParserPipe } from '../../../../filters/rrule-parser.pipe';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'r-rule-text',
  templateUrl: './r-rule-text.component.html',
  standalone: true,
  imports: [DateTimeFormatPipe, RruleParserPipe, AsyncPipe],
})
export class RRuleTextComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  setFullDate(timeString: string) {
    const [hours, minutes] = timeString.split(':');
    const currentDate = new Date(new Date().toUTCString());
    currentDate.setHours(parseInt(hours));
    currentDate.setMinutes(parseInt(minutes));
    return currentDate;
  }
}
